import { Button } from "antd";
import { ManageCommissionForm } from "components/Forms/ManageCommissionForm/ManageCommissionForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId, FormType } from "types/models.ts";

interface AddCommissionDrawerProps {
    onSubmit: () => void;
    offerId?: string;
}

export const AddCommissionDrawer: FC<AddCommissionDrawerProps> = ({ onSubmit, offerId }) => {
    const { t } = usePaldockTranslation("drawers.add-commission");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.AddCommission;
    const formId = FormId.ManageCommissionForm;
    const drawerUtils = useDrawer();

    const handleSubmit = async () => {
        onSubmit?.();
        drawerUtils.hide(id);
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={formId}>
                    {tC("save")}
                </Button>
            }
        >
            <div className={"bg-gray-100 rounded-lg border-dashed border"}>
                <ManageCommissionForm
                    onSubmit={handleSubmit}
                    offerId={offerId}
                    formId={formId}
                    formType={FormType.Create}
                />
            </div>
        </Drawer>
    );
};
